"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1155Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var Erc1155Factory = /** @class */ (function (_super) {
    __extends(Erc1155Factory, _super);
    function Erc1155Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Erc1155Factory.prototype.deploy = function (uri_, overrides) {
        return _super.prototype.deploy.call(this, uri_, overrides || {});
    };
    Erc1155Factory.prototype.getDeployTransaction = function (uri_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, uri_, overrides || {});
    };
    Erc1155Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Erc1155Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Erc1155Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return Erc1155Factory;
}(contracts_1.ContractFactory));
exports.Erc1155Factory = Erc1155Factory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'string',
                name: 'uri_',
                type: 'string',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                indexed: false,
                internalType: 'uint256[]',
                name: 'values',
                type: 'uint256[]',
            },
        ],
        name: 'TransferBatch',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'TransferSingle',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'string',
                name: 'value',
                type: 'string',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
        ],
        name: 'URI',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'accounts',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
        ],
        name: 'balanceOfBatch',
        outputs: [
            {
                internalType: 'uint256[]',
                name: '',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256[]',
                name: 'ids',
                type: 'uint256[]',
            },
            {
                internalType: 'uint256[]',
                name: 'amounts',
                type: 'uint256[]',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeBatchTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'id',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceId',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'uri',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=Erc1155Factory.js.map